import IpWhiteLists from './container';

export default IpWhiteLists;



// WEBPACK FOOTER //
// ./src/views/Setup/IpWhiteLists/index.js